import DashboardPage from './DashboardPage';
import { generateComponentDocs } from '../../utils/documentationUtils';

export default {
  title: 'Pages/DashboardPage',
  component: DashboardPage,
  parameters: {
    layout: 'fullscreen',
    ...generateComponentDocs(
      // 1) What problem does it solve?
      `
The **DashboardPage** consolidates key data—**sortable routes**, **sortable notes**, 
and **recent visits**—so managers and planners can quickly assess activity 
and plan outreach without switching between different pages.
      `,
      // 2) When & how to use it?
      `
Use \`DashboardPage\` as the first-stop overview after logging in. 
Great for scheduling, prioritizing notes, and checking recent visits.

- **Routes**: Sort by "Most Recent", "Upcoming", or "Date". 
  - A plus icon opens \`RouteAddEditModal\` to create a new route.
- **Notes**: Sort by "Priority", "Status", or "Date".
- **Recent Visits**: View a snapshot of the latest site visits.
- **AdvancedSearch**: Expandable search to quickly filter or locate sites.
- **Map icon** redirects to a map view of **all** the organization's sites.
      `,
      // 3) Current Usage
      `
- The default landing page for **Managers** & **Planners** upon logging in.

### **Key Points**
- **Sorting & Filtering**: Intuitive toggles for sorting routes or notes by time, priority, or status.
- **Modal Support**: \`RouteAddEditModal\` for creating/editing routes right from the Dashboard.
- **Search**: An advanced search bar for finding or filtering sites quickly.
- **API Integration**: Relies on \`getRoutes\`, \`getNotes\`, and \`getVisits\` to fetch data on page load.
      `,
      // 4) Related Components
      `
- **[PagesHeader](http://localhost:6006/?path=/docs/components-headers-pagesheader--docs)** for displaying page icon and title.
- **[RouteAddEditModal](http://localhost:6006/?path=/docs/components-modals-routeaddeditmodal--docs)** 
  for creating or editing routes.
- **[AdvancedSearch](http://localhost:6006/?path=/docs/components-advancedsearch--docs)** 
  for site searching and filtering.
- **[Breadcrumbs](http://localhost:6006/?path=/docs/components-breadcrumbs--docs)** 
  for navigational context.
- **[Icon](http://localhost:6006/?path=/docs/components-icons-icon--docs)** for rendering the icons.
      `,
    ),
  },
  tags: ['autodocs'],
};

const Template = () => null;

export const DashboardPageDocsOnly = Template.bind({});
DashboardPageDocsOnly.storyName = 'Docs Only';
